import React,{useEffect,useRef,useState} from 'react';
import {useGuest} from '../services/GuestContext';
import {useAuth} from '../services/authContext';
import {welcomeDefaults} from '../config/welcome.js';
import {presentations} from '../services/presentationCoordinator';
import {usePresentationState} from '../services/usePresentation';
import KeepsakeReveal from './KeepsakeReveal';
import {useOnboarding} from '../services/OnboardingContext';
export default function VisitWelcome(){
 const onboarding=useOnboarding();
 const {current,farm,mutate,presence,first_visit_award_id}=useGuest(),{user}=useAuth();
 const [error,setError]=useState(''),[dismissed,setDismissed]=useState('');
 const lease=useRef<(()=>void)|null>(null);
 const presentation=usePresentationState();
 const scope=user?.email+':'+current?.visit_id;
 const eligible=!onboarding.pending&&!!current&&!first_visit_award_id&&!current.welcome_seen_at&&presence==='on_property'&&user?.status==='Active'&&dismissed!==scope;
 const show=eligible&&presentation.owner==='welcome'&&!!lease.current;
 useEffect(()=>{
  if(eligible&&!presentation.owner&&!presentation.blocked){const acquired=presentations.claim('welcome');if(acquired)lease.current=acquired;}
  if(!eligible){lease.current?.();lease.current=null;}
 },[eligible,presentation]);
 useEffect(()=>()=>{lease.current?.();lease.current=null;},[scope]);
 const dismiss=async()=>{
  if(!current)return;
  setDismissed(scope);lease.current?.();lease.current=null;setError('');
  try{await mutate('/guest/visits/'+current.visit_id,{farm_id:current.farm_id,action:'welcome'},'PUT');}
  catch{setError('Welcome dismissed here. Its acknowledgement could not sync yet.');}
 };
 if(!show||!current)return error?<div role="status" className="fixed bottom-5 left-5 z-[400] max-w-xs rounded-lg border bg-white p-3 text-sm text-gray-700">{error}<button onClick={()=>setError('')} className="ml-2 underline">Dismiss</button></div>:null;
 const content={...welcomeDefaults,...farm?.welcome_content};
 const message=current.first_visit?content.firstArrival:content.returningArrival;
 const unknownHistory=user?.onboarding_eligible&&!user.visited_before_answered;
 return <KeepsakeReveal owner="welcome" property={farm?.name||'Sonata Fields'} title={unknownHistory?`Welcome to ${farm?.name||'the property'}`:current.first_visit?'First visit':`Welcome back, ${user?.name?.split(' ')[0]||''}`} description={unknownHistory?content.introduction:message} medal={current.first_visit} returnLabel="Back to the map" onDismiss={()=>void dismiss()} secondaryTo="/home" secondaryLabel="Property guide"/>;
}
